import { Observable } from 'rxjs/Observable';
import { CommonConstant } from '../../app.constants';
var CacheService = /** @class */ (function () {
    function CacheService() {
        this.cache = new Map();
        this.manuallyDeletedKeys = [
            'InfluencerGroupComparisions',
            'InfluencerGroupConditionOperators',
            'InfluencerGroupConditionTypes',
            CommonConstant.LIST_ADVERTISER_BELONG_TO_USER,
            CommonConstant.DISCOVER_SCROLL_TOP
        ];
        this.DEFAULT_MAX_AGE = 300000;
        this._shouldRemoveCachedData = true;
    }
    Object.defineProperty(CacheService.prototype, "shouldRemoveCachedData", {
        get: function () {
            return this._shouldRemoveCachedData;
        },
        enumerable: true,
        configurable: true
    });
    CacheService.prototype.enableCacheRemoving = function () {
        this._shouldRemoveCachedData = true;
    };
    CacheService.prototype.disableCacheRemoving = function (removingKeys) {
        var _this = this;
        this._shouldRemoveCachedData = false;
        if (Array.isArray(removingKeys)) {
            removingKeys.forEach(function (key) {
                _this.cache.delete(key);
            });
        }
    };
    CacheService.prototype.addManuallyDeletedKey = function (key) {
        if (key) {
            this.manuallyDeletedKeys.push(key);
        }
    };
    CacheService.prototype.clearManuallyDeletedKeys = function () {
        this.manuallyDeletedKeys = [];
    };
    /**
     * Gets the value from cache if the key is provided.
     * If no value exists in cache, then check if the same call exists
     */
    CacheService.prototype.get = function (key, fallback, maxAge) {
        var _this = this;
        if (this.hasValidCachedValue(key)) {
            return Observable.of(this.cache.get(key).value);
        }
        if (!maxAge) {
            maxAge = this.DEFAULT_MAX_AGE;
        }
        if (fallback && fallback instanceof Observable) {
            return fallback.do(function (value) { _this.set(key, value, maxAge); });
        }
        else {
            return Observable.of(null);
        }
    };
    /**
     * Sets the value with key in the cache
     */
    CacheService.prototype.set = function (key, value, maxAge) {
        if (maxAge === void 0) { maxAge = this.DEFAULT_MAX_AGE; }
        this.cache.set(key, { value: value, expiry: Date.now() + maxAge });
    };
    /**
     * Checks if the a key exists in cache
     */
    CacheService.prototype.has = function (key) {
        return this.cache.has(key);
    };
    /**
     * Clear cached value based on key if exists in cache
     */
    CacheService.prototype.clear = function (key) {
        if (this.has(key)) {
            this.cache.delete(key);
        }
    };
    CacheService.prototype.clearAll = function () {
        for (var _i = 0, _a = Array.from(this.cache.keys()); _i < _a.length; _i++) {
            var key = _a[_i];
            if (this.manuallyDeletedKeys.indexOf(key) < 0) {
                this.cache.delete(key);
            }
        }
    };
    /**
     * Checks if the key exists and has not expired.
     */
    CacheService.prototype.hasValidCachedValue = function (key) {
        if (this.cache.has(key)) {
            if (this.cache.get(key).expiry < Date.now()) {
                this.cache.delete(key);
                return false;
            }
            return true;
        }
        else {
            return false;
        }
    };
    return CacheService;
}());
export { CacheService };



// WEBPACK FOOTER //
// ./src/app/services/cache/cache.service.ts.pre-build-optimizer.js